module.exports = __webpack_public_path__ + "static/media/10.6b9f0685.jpg";